/* eslint-disable import/no-anonymous-default-export */
import { ENDPOINT, HTTP } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

export default (userId) => 
    fetchFromLawfeed({ method: HTTP.GET, endpoint: ENDPOINT.DOCUMENTS, routeParams:[userId] });